import React, { useMemo, useEffect, useState } from 'react'
import { pick, uniq } from 'lodash-es'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { JsonEditor, Button, Modal } from '@ow/comps'

// 3层
export const listToLayouts = (list, bindSlugs) => {
  const obj = {}
  const layoutsData = []
  // 过滤掉末级
  list
    .filter((v) => v.isParentNode)
    .forEach((item) => {
      obj[item.id] = {
        level: item.level,
        title: item.title,
        parentId: item.parentId,
        isParentNode: item.isParentNode,
        content: {
          cols: 2,
          rows: 1,
          type: 'groups',
          title: item.title,
          children: [],
        },
      }
    })
  // 绑定指标
  list
    .filter((v) => !v.isParentNode)
    .forEach((item) => {
      const slug = bindSlugs.find((l) => l.indexOf(item.objectId) > -1)
      obj[item.id] = {
        slug,
        // objectId: item.objectId,
        level: item.level,
        parentId: item.parentId,
        leaf: true,
      }
    })

  Object.values(obj).forEach((item) => {
    if (item.parentId && obj[item.parentId]) {
      if (
        !(obj[item.parentId].content && obj[item.parentId].content.children) &&
        !item.leaf
      ) {
        obj[item.parentId].content.children = []
      }
      if (item.isParentNode) {
        // 父级
        obj[item.parentId].content.children.push(item)
      } else if (item.leaf) {
        // 末级，被绑定，配置在父级的fileds里面
        if (!obj[item.parentId].fields) {
          obj[item.parentId].fields = {}
          obj[item.parentId].fields.children = []
        }
        obj[item.parentId].fields.cols = 2
        obj[item.parentId].fields.rows = 1
        obj[item.parentId].fields.children.push({
          slug: item.slug,
        })
        obj[item.parentId].content = null
      }
      if (item.level > 2) {
        item.title = obj[item.parentId].title + '-' + item.title
      }
    } else {
      layoutsData.push(item)
    }
  })

  // 最后一步处理

  return layoutsData
}

const standardBindLayouts = () => {
  const [layouts, setLayouts] = useState({})
  // const [maxLevel, setMaxLevel] = useState(0)
  const [standards, setStandards] = useState([])
  const { fields } = useTbViewStore((state) => pick(state, ['fields']))
  const { getDitto } = useAppEx()
  const standardModel = getDitto('standard')

  const linkStandardSlugs = useMemo(() => {
    return fields
      .filter((v) => v.ownViewDef && v.ownViewDef.isBindStandard)
      .map((v) => v.slug)
  }, [fields])

  // 生成布局
  const makeupLayoutsJson = (nodes = []) => {
    setLayouts(
      listToLayouts(
        nodes,
        fields.map((v) => v.slug)
      )
    )
  }

  useEffect(() => {
    standardModel.fetchEffectiveData().then((data) => {
      const arr = data
        .map((v) => {
          return { ...v, id: v.objectId }
        })
        .sort((a, b) => {
          return b.level - a.level
        })
      // const level = max(arr.map((v) => v.level))

      // 目前绑定的末级指标ids
      const bindStandardIds = arr
        .filter((v) =>
          linkStandardSlugs.find((l) => l.indexOf(v.objectId) > -1)
        )
        .map((v) => v.objectId)

      // 由于从大到小排序，所以可保证父级指标不会丢失
      arr.forEach((v) => {
        // 是否是绑定指标（包含对应父级）
        if (bindStandardIds.includes(v.objectId) && v.level > 1) {
          bindStandardIds.push(v.parentId)
        }
      })
      // setMaxLevel(level)
      setStandards(
        arr.filter((v) => uniq(bindStandardIds).includes(v.objectId))
      )
    })
  }, [linkStandardSlugs])

  return (
    <Modal
      size="lg"
      trigger={<Button type="primary">生成详情布局</Button>}
      height={500}
    >
      <div className="w-full" style={{ height: '500px' }}>
        <Button
          type="primary"
          onClick={() => {
            makeupLayoutsJson(standards)
          }}
        >
          生成详情布局
        </Button>
        <JsonEditor value={layouts || {}} />
      </div>
    </Modal>
  )
}
export default standardBindLayouts
